export default __webpack_public_path__ + "static/media/MarwaAwwad.d1902429.jpeg";